const actions = {
  SET_STATE: 'techendpay/SET_STATE',
  GET_TRANSACTION_LOG: 'techendpay/GET_TRANSACTION_LOG',
  PROCESS_TRANSACTIONS: 'techendpay/PROCESS_TRANSACTIONS',
  GET_TRANSACTION_BATCHES: 'techendpay/GET_TRANSACTION_BATCHES',
  ALAT_PAY_TO_WALLET: 'techendpay/ALAT_PAY_TO_WALLET',
}

export default actions
